import React from "react";
import cs from "classnames";
import styles from "./styles.module.scss";
import { TariffLabelProps, TariffLevel } from "./types";

// Each level maps to a color tone (Figma 476:68169).
const TONE: Record<TariffLevel, string> = {
  trial: styles["tone-warning"],
  starter: styles["tone-warning"],
  advanced: styles["tone-indigo"],
  expert: styles["tone-cyan"],
  special: styles["tone-cyan"],
};

/** Tariff/profile-level pill. Dumb component — level + texts via props. */
export const TariffLabel: React.FC<TariffLabelProps> = ({
  level,
  label,
  meta,
  className,
}) => (
  <span className={cs(styles.chip, TONE[level], className)}>
    <span className={styles.dot} aria-hidden />
    <span className={styles.label}>{label}</span>
    {/* data hook so hosts can drop the meta line when space is tight */}
    <span className={styles.meta} data-tariff-meta>
      {meta}
    </span>
  </span>
);

export default TariffLabel;
